import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import {
  MAIN_FONT_FAMILY,
  STORAGE_KEYS,
} from "../../../data/constant/Constants";
import { COLOR_WHITE } from "../../../data/colors/Colors";
import { supportedLngs } from "../../../i18n/config";
import React from "react";
import SharedPreferences from "../../../core/utils/SharedPreferences";
import { useTranslation } from "react-i18next";
import { LanguageRounded } from "@mui/icons-material";

export function LanguageSelectView() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = React.useState(
    SharedPreferences.getString(STORAGE_KEYS.LANGUAGE) ?? i18n.resolvedLanguage
  );

  const handleChange = (event: SelectChangeEvent) => {
    event.preventDefault();
    const newLang = event.target.value as string;
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
    SharedPreferences.setString(STORAGE_KEYS.LANGUAGE, newLang);
  };
  return (
    <Select
      sx={{
        fontFamily: MAIN_FONT_FAMILY,
        borderRadius: 12,
        color: "white",
        fontSize: 12,
        "& .MuiSelect-select": {
          paddingRight: 2,
          paddingLeft: 1.5,
          paddingTop: 1,
          paddingBottom: 1,
        },
        ".MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_WHITE,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_WHITE,
          borderWidth: 1,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_WHITE,
        },
        ".MuiSvgIcon-root ": {
          fill: "white !important",
          fontSize: 20,
        },
      }}
      inputProps={{
        MenuProps: {
          PaperProps: {
            sx: {
              borderRadius: 4,
            },
          },
        },
      }}
      value={language}
      onChange={handleChange}
      IconComponent={LanguageRounded}
    >
      {Object.entries(supportedLngs).map(([code, name]) => {
        return (
          <MenuItem
            key={code}
            sx={{ fontFamily: MAIN_FONT_FAMILY }}
            value={code}
          >
            {name}
          </MenuItem>
        );
      })}
    </Select>
  );
}
